fx.ns("desktop.print", class CheckPrintPanel extends fx.components.PopupPanel {

    constructor(data)
    {
        super(data);

		this.destroyOnSwitch = true;
        this.contentWidth = 610;
        this.contentHeight = 350;
        //this.showClose = !fx.get("previewMode");

        this.mode = "navigation" ;//fx.get("previewMode") ? "navigation" : "popup";
    }
  
    create()
    {
        super.create();

        if (!this.data.report().failed)
        {
            if (this.data.creation.isScrapBooking)
                this.data.event("no-upsell-available");
            else
                this.data.event("next-step");
            return;
        }

		let mainbox = new fx.components.Box("container");

        // header
        mainbox.addChild(new shared.component.Person(fx.get("assets").personAdvice), {width:200, height : 200, left : "center"});
        //mainbox.addChild(new fx.components.Image({data: fx.assets.warningIcon, className: "warning"}), {width:20, height : 20, top : 170, left : "center"});

        let text;

        if (this.data.creation.isScrapBooking)
        {
            if(this.data.creation.numPrints < this.data.creation.minPages)
                text = fx.text("Vous devez avoir au moins <span class='numPhotosLabel'>$ photos</span> pour commander votre album", this.data.creation.minPages);
            else 
                text = fx.text("Vous devez avoir moins de <span class='numPhotosLabel'>$ photos</span> pour commander votre album", this.data.creation.maxPages);
        }
        else
        {
            if(this.data.creation.numPrints < this.data.creation.minPages)
                text = fx.text("Vous devez avoir au moins <span class='numPhotosLabel'>$ photos</span> pour commander vos tirages", this.data.creation.minPages);
            else 
                text = fx.text("Vous devez avoir moins de <span class='numPhotosLabel'>$ photos</span> pour commander vos tirages", this.data.creation.maxPages);
        }
 
        mainbox.addChild(new fx.components.Text({text: text, className:"explanation center bold"}), {height:100, left:"center", top:200, width:"400"});

        
        let hbox = new fx.components.HBox();
        this.cancelButton = new fx.components.Button( fx.text("J'ai compris"));
        this.cancelButton.attr("data-testid", "checkbook-cancel");
        
        hbox.addChild(this.cancelButton, {width : 200});
        mainbox.addChild(hbox, {top: 320, left : "center"});

        this.addChild(mainbox, { top: "center", left: "center", height: 350, width: 600 })
    }

    onReady()
    {
        super.onReady();

        this.on("click", this.close, this.cancelButton);
    }

    close()
    {
		super.close();
		this.data.event("show-editor");
    }
  


});